export default {
    props: {
        email: {type: String, default: ""},
        loginCode: {type: String, default: ""},
        canLogin: {type: Boolean, default: false},
        startLogin: {type: Boolean, default: false},
        isLogged: {type: Boolean, default: false},
        showLoginFields: {type: Boolean, default: false},
        showShipping: {type: Boolean, default: false},
        isInputLoding: {type: Boolean, default: false},
        loadingFieldName: {type: String, default: ""},
        emailError: {type: Boolean, default: false},
        emailMistake: {type: Boolean, default: false},
        labels: {type: Object, default: () => ({})},
    },
    emits: ["update:email", "update:loginCode", "login", "guest", "check-email"],
    template: `
        <div>
            <div class="pure-u-1-1">
                <div class="h-captcha" ref="captcha1"></div>
                <div v-show="canLogin" id="canLogin" class="pure-g item-aligns-center mb-5">
                    <div class="pure-u-1 text-center">
                        <h3>{{ labels.fasterShopping }}</h3>
                        <p>{{ labels.choose }}</p>
                        <div>
                            <div class="switch-button">
                                <button type="button" class="btn btn-white" @click="$emit('login')">{{ labels.logIn }}</button>
                                <button type="button" class="btn btn-white" @click="$emit('guest')">{{ labels.guest }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isInputLoding && loadingFieldName == 'email'">
                    <div class="skeleton skeleton-text"></div>
                    <div class="skeleton skeleton-text skeleton-text__body"></div>
                    <div class="skeleton skeleton-text skeleton-text__body"></div>
                </div>
                <div v-show="startLogin" id="startLogin" class="pure-g item-aligns-center mb-5">
                    <div class="pure-u-1 pure-u-sm-2-3">
                        <h3>{{ labels.fasterShopping }}</h3>
                        <p>{{ labels.enterCode }}</p>
                        <p>{{ labels.codeText }}</p>
                    </div>
                    <div class="pure-u-1 pure-u-sm-1-3">
                        <div class="form-group">
                            <label for="code">{{ labels.pinCode }}</label>
                            <input id="code" type="number" :value="loginCode" @input="$emit('update:loginCode', $event.target.value)" :class="{ loading: isInputLoding && loadingFieldName == 'pin' }">
                        </div>
                    </div>
                </div>
                <p class="alert alert-danger p-0 m-0" role="alert" v-if="emailMistake">{{ labels.notValidEmail }}</p>
                <p class="alert alert-danger p-0 m-0" role="alert" v-if="emailError">{{ labels.missingEmail }}</p>
            </div>
        </div>
    `,
};